import React from 'react';

/**
 * Native <details> accordion: readable by crawlers with no JavaScript, and it
 * matches the FAQPage structured data one-for-one.
 */
export const Faq = ({ items, testIdPrefix = 'faq' }) => (
  <div className="divide-y divide-amber-100 rounded-2xl border border-amber-100 bg-white shadow-sm">
    {items.map((item, i) => (
      <details key={item.question} className="group px-5 py-4" data-testid={`${testIdPrefix}-item-${i}`}>
        <summary className="flex cursor-pointer list-none items-start justify-between gap-4 text-left">
          <h3 className="text-base md:text-lg font-semibold text-gray-900">{item.question}</h3>
          <span
            aria-hidden="true"
            className="mt-1 flex-shrink-0 text-2xl leading-none text-amber-600 transition-transform duration-200 group-open:rotate-45"
          >
            +
          </span>
        </summary>
        <p className="mt-3 text-sm md:text-base leading-relaxed text-gray-600">{item.answer}</p>
      </details>
    ))}
  </div>
);

export default Faq;
